import { render, staticRenderFns } from "./CopyData.vue?vue&type=template&id=161954af"
import script from "./CopyData.vue?vue&type=script&lang=js"
export * from "./CopyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports